import { useRouter } from "next/router";
import { useSolutionsSelect } from "@/states/solution.state";
import { useHomePageTypesButton } from "@/states/ui.state";
import { useFrom } from "@/states/common.state";

const useRedirectToBlog = () => {
  const router = useRouter();

  const { setFrom } = useFrom();
  const { homePageTypesButton, setFilterHomePageTypesButton } = useHomePageTypesButton();
  const { setSolutionsType } = useSolutionsSelect();

  const handleClick = (type: string, route: string) => {
    const selectedType = homePageTypesButton.filter((e) => e.type === type);
    if (selectedType) {
      setSolutionsType({
        solutionSelectedType: selectedType[0].type,
      });
      setFilterHomePageTypesButton(selectedType[0].type);
      setFrom("solutions");
      router.push(route);
    }
  };

  return { handleClick };
};

export default useRedirectToBlog;
